var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIcon = function SvgZoomIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#EDECED",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#67708C",
    d: "M8.889 18.667a.89.89 0 0 1 .889.889v2.666h2.666a.889.889 0 0 1 0 1.778H9.778A1.78 1.78 0 0 1 8 22.222v-2.666a.89.89 0 0 1 .889-.89m14.222 0a.89.89 0 0 1 .883.785l.006.104v2.666a1.78 1.78 0 0 1-1.644 1.774l-.134.004h-2.666a.89.89 0 0 1-.104-1.772l.104-.006h2.666v-2.666a.89.89 0 0 1 .89-.89M22.222 8a1.78 1.78 0 0 1 1.774 1.644l.004.134v2.666a.89.89 0 0 1-1.772.104l-.006-.104V9.778h-2.666a.89.89 0 0 1-.104-1.772L19.556 8zm-9.778 0a.89.89 0 0 1 .104 1.772l-.104.006H9.778v2.666a.89.89 0 0 1-1.772.104L8 12.444V9.778a1.78 1.78 0 0 1 1.644-1.774L9.778 8z"
  })));
};
export default SvgZoomIcon;